import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/services";

export const ServiceGrid = ({ slugs, dark }) => (
  <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
    {slugs.map((slug, i) => {
      const s = SERVICES[slug];
      if (!s) return null;
      return (
        <motion.div
          key={slug}
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.55, delay: (i % 3) * 0.08 }}
        >
          <Link
            to={`/services/${slug}`}
            data-testid={`service-card-${slug}`}
            className={`group flex h-full flex-col overflow-hidden border transition-colors duration-500 ${
              dark
                ? "border-white/10 bg-govx-charcoal/40 hover:border-govx-lime/50"
                : "border-govx-charcoal/10 bg-white hover:border-govx-green"
            }`}
          >
            <div className="relative h-40 overflow-hidden">
              <img
                src={s.image}
                alt={s.title}
                className="h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0"
              />
              <div className={`absolute inset-0 bg-gradient-to-t ${dark ? "from-govx-charcoal" : "from-black/50"} to-transparent`} />
              <span className="absolute left-4 top-4 font-mono text-[0.62rem] text-govx-lime">
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-6">
              <h3 className={`font-display text-xl font-medium tracking-tight ${dark ? "text-govx-paper" : "text-govx-charcoal"}`}>
                {s.title}
              </h3>
              <p className={`mt-2 flex-1 text-sm leading-relaxed ${dark ? "text-govx-grey" : "text-govx-charcoal/60"}`}>
                {s.tagline}
              </p>
              <span className={`mt-5 inline-flex items-center gap-1.5 text-sm font-semibold ${dark ? "text-govx-paper group-hover:text-govx-lime" : "text-govx-green"}`}>
                Explore
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </div>
          </Link>
        </motion.div>
      );
    })}
  </div>
);
